/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { decisionRatedByDtoSchema } from "./decisionRatedByDtoSchema.ts";
import { z } from "zod/v4";

export const decisionDtoSchema = z.object({
  finalDecision: z.optional(
    z.enum(["Qualified", "Rejected", "InReview"]).default("Qualified"),
  ),
  decisionLabel: z.optional(z.string()),
  get ratedBy() {
    return z.array(decisionRatedByDtoSchema).optional();
  },
  rationale: z.optional(z.string()),
  popoverNotes: z.optional(z.array(z.string())),
  extractedIndustry: z.optional(z.string()),
  extractedBusinessModel: z.optional(z.string()),
  extractedStage: z.optional(z.string()),
  extractedCountry: z.string().nullish(),
});
